var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingColumnsSolid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4093 0.121271C11.7843 -0.0404238 12.2156 -0.0404238 12.5906 0.121271L23.0906 4.62141C23.7468 4.90313 24.1125 5.60626 23.9672 6.30001C23.8265 6.99844 23.2125 7.45782 22.4578 7.50001V7.87501C22.4578 8.49844 21.9984 9.00001 21.3328 9.00001H2.58278C2.00341 9.00001 1.45778 8.49844 1.45778 7.87501V7.50001C0.787939 7.45782 0.173782 6.99844 0.0305699 6.30001C-0.112624 5.60626 0.254454 4.90313 0.908876 4.62141L11.4093 0.121271ZM12 6.00001C12.8297 6.00001 13.5 5.32969 13.5 4.50001C13.5 3.67172 12.8297 3.00001 12 3.00001C11.1703 3.00001 10.5 3.67172 10.5 4.50001C10.5 5.32969 11.1703 6.00001 12 6.00001ZM5.95778 19.5H7.83278V10.5H10.8328V19.5H13.125V10.5H16.125V19.5H18V10.5H21V19.7016C21.0281 19.7156 21.0562 19.6922 21.0843 19.7531L23.3343 21.2531C23.8828 21.6188 24.1265 22.3031 23.9343 22.9359C23.7422 23.5688 23.1609 24 22.5 24H1.45778C0.839032 24 0.255814 23.5688 0.0642824 22.9359C-0.127296 22.3031 0.117861 21.6188 0.667939 21.2531L2.91794 19.7531C2.94466 19.6922 2.97231 19.7156 2.95778 19.7016V10.5H5.95778V19.5Z",
    fill: "#212737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingColumnsSolid2);
export default __webpack_public_path__ + "static/media/building-columns-solid-2.3eb973bc377491a9b4763d60fb5371f2.svg";
export { ForwardRef as ReactComponent };